import { useState, useEffect } from 'react'
import clsx from 'clsx'
import classes from '../Card.module.scss'
import PropTypes from 'prop-types'
import { AudioComponentControl } from '@educaplay/core/components/AudioComponentControl'

function sizeCalc(long) {
  if (long < 3) {
    return "--xl";
  } else if (long < 25) {
    return "--l";
  } else if (long < 51) {
    return "--m";
  } else if (long < 125) {
    return "--s";
  } else {
    return "--xs";
  }
}

export function CardTextAudio({ text, audioSrc, autoplay }) {
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    if(!autoplay) return;

    const timer = setTimeout(() => {
        setPlaying(true);
    }, 800)

    return () => {
      clearTimeout(timer);
    }
  }, [autoplay])

  const sizeClass = sizeCalc(text.length)
  return (
    <div className={clsx(classes.card__content, classes["card--text-sound"])}>
      <AudioComponentControl source={audioSrc} autoplay={playing} className={classes.audioComponent} />
      <div className={clsx(classes["card-text"], classes[sizeClass])}>
        {text}
      </div>
    </div>
  )
}

CardTextAudio.propTypes = {
  text: PropTypes.string.isRequired,
  audioSrc: PropTypes.string.isRequired
}